import { Link, useParams } from "react-router-dom";
import { useContent, RichText, fmtDay } from "@/lib/content";

const Wrap = ({ children }) => <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 sm:py-20">{children}</div>;

export function ContentPage() {
  const { slug } = useParams();
  const p = useContent(`/pages/${slug}`, undefined);
  if (p === undefined) return <Wrap><p className="text-stone-500" data-testid="content-page-loading">Caricamento...</p></Wrap>;
  if (!p) return <Wrap><p data-testid="content-page-missing">Pagina non trovata.</p></Wrap>;
  return (
    <Wrap>
      {p.eyebrow && <p className="font-display text-sm uppercase tracking-[0.2em] text-amber-600">{p.eyebrow}</p>}
      <h1 className="mt-2 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-testid="content-page-title">{p.title}</h1>
      {p.image && <img src={p.image} alt={p.title} className="mt-8 max-h-[420px] w-full rounded-2xl border-2 border-black object-cover" data-testid="content-page-image" />}
      <RichText text={p.body} className="mt-8 text-stone-700" testid="content-page-body" />
    </Wrap>
  );
}

export function NewsListPage() {
  const posts = useContent("/posts", null);
  return (
    <div className="mx-auto max-w-[1100px] px-4 py-14 sm:px-6 sm:py-20">
      <p className="font-display text-sm uppercase tracking-[0.2em] text-amber-600">Dal negozio</p>
      <h1 className="mt-2 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-testid="news-title">News</h1>
      {posts && !posts.length && <p className="mt-8 text-stone-500" data-testid="news-empty">Nessun articolo pubblicato per ora.</p>}
      <div className="mt-10 grid gap-6 md:grid-cols-2" data-testid="news-list">
        {(posts || []).map((p) => (
          <Link key={p.id} to={`/news/${p.slug}`} className="sticker-btn group overflow-hidden rounded-2xl bg-white" data-testid={`news-card-${p.slug}`}>
            {p.cover && <img src={p.cover} alt={p.title} className="aspect-[16/9] w-full object-cover" />}
            <div className="p-5">
              <p className="text-xs text-stone-500">{fmtDay(p.published_at)}</p>
              <p className="mt-1 font-display text-xl font-bold leading-snug group-hover:text-amber-600">{p.title}</p>
              {p.excerpt && <p className="mt-2 text-sm text-stone-600">{p.excerpt}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function NewsPostPage() {
  const { slug } = useParams();
  const p = useContent(`/posts/${slug}`, undefined);
  if (p === undefined) return <Wrap><p className="text-stone-500">Caricamento...</p></Wrap>;
  if (!p) return <Wrap><p data-testid="news-post-missing">Articolo non trovato.</p></Wrap>;
  return (
    <Wrap>
      <Link to="/news" className="text-sm text-amber-600" data-testid="news-back">← Tutte le news</Link>
      <p className="mt-6 text-xs text-stone-500">{fmtDay(p.published_at)}</p>
      <h1 className="mt-1 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-testid="news-post-title">{p.title}</h1>
      {p.cover && <img src={p.cover} alt={p.title} className="mt-8 max-h-[460px] w-full rounded-2xl border-2 border-black object-cover" />}
      <RichText text={p.body} className="mt-8 text-stone-700" testid="news-post-body" />
    </Wrap>
  );
}
